/**
 * Feature Registry
 * Maps feature IDs to the version they were introduced in.
 * 
 * IMPORTANT: Feature highlights are only shown when the current version EXACTLY matches
 * the introduced version. This means:
 * - Feature introduced in 8.3.2 will ONLY show when version is 8.3.2
 * - New users joining in 8.4.0 will NOT see the 8.3.2 feature highlight
 * - Each feature highlight is shown only during its specific release version
 * 
 * When adding a new feature highlight:
 * 1. Add the feature ID and version to this registry
 * 2. Use the feature ID in the component where you want to show the highlight
 */

export const FEATURE_REGISTRY = {
  "sidebar-toggle": "8.3.2",
  // Add more features here as needed:
  // "new-dashboard": "8.4.0",
  // "enhanced-search": "8.4.1",
};

/**
 * Get the version a feature was introduced in
 * @param {string} featureId - The feature identifier
 * @returns {string|null} - The version string or null if feature not found
 */
export const getFeatureVersion = (featureId) => {
  return FEATURE_REGISTRY[featureId] || null;
};

